import React from "react";
import "./style.css";

const ProductSkeleton = () => {
  return (
    <div className="productThumb skeleton-card">
      <div className="img-container position-relative">
        <div className="imgWrapper">
          <div className="skeleton skeleton-img w-100 h-100" />
        </div>
      </div>

      <div className="info">
        <div className="skeleton skeleton-title mb-2" style={{ height: '20px', width: '80%' }} />
        <div className="skeleton skeleton-desc mb-2" style={{ height: '36px', width: '100%' }} />
        <div className="skeleton skeleton-rating mb-2" style={{ height: '16px', width: '40%' }} />
        <div className="skeleton skeleton-brand mb-2" style={{ height: '18px', width: '30%' }} />
        <div className="d-flex align-items-center mt-3">
          <div className="skeleton skeleton-price" style={{ height: '22px', width: '30%' }} />
        </div>
      </div>
    </div>
  );
};

export default ProductSkeleton;
